import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { Doc } from '@/api/types/backend-dto-types';
import { ChildDocumentPopover } from '@/new/components/doc-viewer/child-document-popover';
import { Icon } from '@/new/components/icon';
import { Label } from '@/new/components/shadcn/label';

export function DocRelationships({ doc }: { doc: Doc }) {
  const { matterId, subsetId } = useParams();
  return (
    <div className="space-y-4">
      <Label className="text-xs uppercase">Document Relationships</Label>
      <div className="my-2 space-y-3">
        {doc.file.parentFile && (
          <div className="flex items-center gap-3 rounded-md border border-blue-200 bg-blue-50/50 p-3">
            <Icon className="lucide--file text-blue-600" />
            <div className="min-w-0 flex-1">
              <Label className="text-xs font-medium tracking-wide text-blue-600 uppercase">Attachment of</Label>
              <Link
                className="block truncate text-sm font-medium text-blue-900 hover:text-blue-700"
                to={(() => {
                  if (doc.file.parentFile?.doc?.id) {
                    return `/matters/${matterId}/subsets/${subsetId}/docs/${doc.file.parentFile.doc.id}`;
                  }
                  return `/matters/${matterId}/subsets/${subsetId}/docs`;
                })()}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                {doc.file.parentFile.name}
              </Link>
            </div>
          </div>
        )}

        {doc.file.childFiles && doc.file.childFiles.length > 0 && (
          <div className="flex items-center gap-3 rounded-md border border-green-200 bg-green-50/50 p-3">
            <Icon className="lucide--paperclip text-green-600" />
            <div className="min-w-0 flex-1">
              <div className="text-xs font-medium tracking-wide text-green-600 uppercase">Attachments</div>
              <ChildDocumentPopover childFiles={doc.file.childFiles}>
                <button className="text-sm font-medium text-green-900 transition-colors hover:text-green-700">
                  {doc.file.childFiles.length} attachment{doc.file.childFiles.length !== 1 ? 's' : ''}
                </button>
              </ChildDocumentPopover>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
